import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class Tilde extends Component {
     constructor(props) {
          super(props);
          this.state = {
               id:props.id,
               checked:props.checked,
          };
     }

     componentWillReceiveProps(nextProps) {
          if(this.state.id !== nextProps.id || this.state.checked !== nextProps.checked){
               this.setState({
                    id:nextProps.id,
                    checked:nextProps.checked,
               });
          }
     }

     switch(){
          if(this.props.valueChanged){
               this.setState(
                    {checked:!this.state.checked},
                    ()=>this.props.valueChanged(this.state.id, this.state.checked)
               );
          }
     }

     render() {
          const {checked} = this.state;
          return (
               <div>
               <input disabled={this.props.disabled} type="checkbox" name={"checkboxStar"+this.state.id} id={"checkboxStar"+this.state.id} className="checkbox-star" checked={checked == true} onChange={ () => this.switch() }/>
               <label className="w-75" htmlFor={"checkboxStar"+this.state.id} style={{cursor:'pointer'}}>
               {
                    checked == true ?
                    <div className="bg-success opcion-si">
                    <small>
                    SI
                    </small>
                    </div>
                    :
                    <div className="bg-danger opcion-no">
                    <small>
                    NO
                    </small>
                    </div>
               }
               </label>
               </div>
          );
     }
}

export default Tilde;



// WEBPACK FOOTER //
// ./src/views/Vendedores/Tilde.js